// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"AppNotification_snackbar__i2AuF","text":"AppNotification_text__1-dvS"};